var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"VueTables__primary-content"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.singleCourseStatus)?_c('div',{staticClass:"VueTables__secondary-content"},[_vm._v("\n        "+_vm._s(_vm.trans('reporting.label.assigned_at'))+" "+_vm._s(_vm.singleCourseStatus)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }